<template>
  <!-- height:100% -->
  <div style="background-color: white">
    <!-- <router-link to="/sbsj">立即申请</router-link>
    <el-button type="primary"     v-preventReClick   @click="login">登录</el-button> -->

    <!-- bannerTop -->
    <div
      class="t_banner_top"
      :style="{ backgroundImage: 'url(' + topimg + ')' }"
    >
      <div class="t_banner_con">
        <div class="t_banner_up">
          <div class="t_banner_top_imgbox">
            <img src="@/assets/img/logo/logo.png" style="height: 33px">
            <div style="display: flex; align-items: center" v-if="!isEmpty(kfdh)">
              <img
                src="@/assets/img/topphone.png"
                style="
                  height: 14px;
                  margin-left: 20px;
                  margin-right: 6px;
                  margin-top: 11px;
                "
              >
              <span style="display: inline-block;color: white;font-size: 20px;margin-top: 5px;">
                客服热线：<span>{{kfdh}}</span>
              </span>
<!--              <img
                src="@/assets/img/login/kedudianhua.png"
                style="height: 20px; margin-top: 9px"
              >-->
              <!--  <img
                src="@/assets/img/topphonenum.png"
                style="height: 20px; margin-top: 9px"
              /> -->
            </div>
          </div>
          <div class="t_banner_top_search">
            <img
              src="@/assets/img/search.png"
              style="width: 15px; height: 15px; margin-right: 12px"
            >
            <input
              v-model="searchbh"
              type="text"
              style="
                background-color: rgba(255, 255, 255, 0);
                border: none;
                outline: none;
                width: 270px;
                color: white;
              "
              placeholder="请输入许可证编号进行核查"
            >
            <div v-preventReClick class="t_search_btn" @click="hcShow">
              核查
            </div>
          </div>
        </div>
        <div class="t_nav_list">
          <div
            :class="{ active: isActive == 1 }"
            @click="nav(1)"
          >
            首页
          </div>
          <div
            :class="{ active: isActive == 2 }"
            @click="nav(2)"
          >
            法律法规
          </div>
          <div
            :class="{ active: isActive == 3 }"
            @click="nav(3)"
          >
            政策文件
          </div>
          <!--  <div
            :class="{ active: isActive == 4 }"
            v-preventReClick
            @click="nav(4)"
          >
            新闻中心
          </div> -->
          <div
            :class="{ active: isActive == 5 }"
            @click="nav(5)"
          >
            帮助中心
          </div>
          <div @click="appdownload">APP下载</div>
          <!--          <div @click="connectToUs">联系我们</div>-->
          <div
            :class="{ active: isActive == 7 }"
            @click="nav(7)"
          >
            更新日志
          </div>
          <!-- @y1215详情 -->
          <!-- <div    v-preventReClick   @click="nav(6)">新闻中心详情</div> -->
        </div>
      </div>
    </div>

    <div class="t_con_box">
      <!-- 通知 -->
      <div v-if="navtab1" class="t_notice_box">
        <div class="t_title_box">
          <img
            v-if="tzgg"
            src="@/assets/img/flfgcolor.png"
            class="t_title_color"
          >
          <img
            v-else
            src="@/assets/img/flfgno.png"
            class="t_title_no"
            @click="tzggtab"
          >
          <img
            v-if="flfg"
            src="@/assets/img/zcwjcolor.png"
            class="t_title_color"
          >
          <img
            v-else
            src="@/assets/img/zcwjno.png"
            class="t_title_no"
            @click="flfgtab"
          >
        </div>
        <div v-if="tzgg">
          <div
            v-for="(item, k) in flfgData"
            :key="k"
            class="t_notice_item"
            @click="hflfgData(item)"
          >
            <div class="t_zero" />
            <div class="t_notice_so">
              {{ item.title }}
            </div>
          </div>
        </div>
        <div v-if="flfg">
          <div
            v-for="(item, k) in zcwjData"
            :key="k"
            class="t_notice_item"
            @click="hflfgData(item)"
          >
            <div class="t_zero" />
            <div class="t_notice_so">
              {{ item.title }}
            </div>
          </div>
        </div>
      </div>
      <!-- banner -->
      <div v-if="navtab1" class="t_banner_box">
        <el-carousel height="400px">
          <el-carousel-item v-for="(item, index) in swiperList" :key="index">
            <img :src="item.curImg" style="width: 100%">
          </el-carousel-item>
        </el-carousel>
      </div>
      <!-- 登录 -->
      <div v-if="navtab1" class="t_login_box">
        <div
          class="t_title_box"
          style="justify-content: flex-start; margin-bottom: 40px"
        >
          <img src="@/assets/img/logincolor.png" class="t_title_color">
        </div>
        <input
          v-model="username"
          type="text"
          placeholder="请输入账号"
          class="t_input_user"
        >
        <input
          v-model="password"
          type="password"
          placeholder="请输入密码"
          class="t_input_user"
          style="margin-top: 20px; margin-bottom: 20px"
        >
        <div
          style="display: flex; display: flex; justify-content: space-between"
        >
          <input
            v-model="code"
            type="text"
            placeholder="请输入图片验证码"
            class="t_input_user"
            style="width: 177px"
          >
          <img
            :src="codeimgurl"
            style="height: 100%; width: 80px; cursor: pointer"
            @click="codeimg"
          >
        </div>
        <div class="t_forgetpwd" @click="wjfont">
          忘记密码？
        </div>
        <div class="t_login_btnbox">
          <div class="t_reg" @click="register">注册</div>
          <div
            v-preventReClick
            class="t_log"
            style="color: white; background-color: #0f70ff"
            @click="login"
            @keyup.enter="login"
          >
            登录
          </div>
        </div>
      </div>
      <!-- 流程 -->
      <div v-if="navtab1" class="t_flow_box">
        <div class="t_title_box" style="justify-content: flex-start">
          <img src="@/assets/img/joincolor.png" class="t_title_color">
        </div>
        <div class="t_step_box">
          <img src="@/assets/img/step.png" style="width: 1045px">
          <div class="t_step_item" style="top: 131px; left: 51px">
            单位信息员通过手机号进行注册
          </div>
          <div class="t_step_item" style="top: 36px; left: 315px">
            填写单位基本信息
          </div>
          <div class="t_step_item" style="top: 124px; left: 545px">
            上传相关资质证件
          </div>
          <div class="t_step_item" style="top: 46px; left: 744px">
            录入相关化学品信息
          </div>
          <div class="t_step_item" style="top: 148px; left: 973px">
            等待公安审核
          </div>
        </div>
      </div>
      <!-- 新闻中心 -->
      <!--
            <img src="@/assets/img/newsimg.png" alt="" /> -->
      <!-- <div v-if="navtab1" class="t_news_box">
        <div class="t_title_box" style="justify-content: space-between">
          <img src="@/assets/img/newscolor.png" class="t_title_color" />
          <div
            style="color: #636363; font-size: 13px"
            v-preventReClick
            @click="nav(4)"
          >
            更多>
          </div>
        </div>
        <div class="t_news_list2">
          <div
            v-for="(item, k) in t_news_boxData"
            :key="k"
            class="t_news_item"
            v-preventReClick
            @click="hXwzxlb(item, '首页')"
          >
            <img
              :src="item.picture"
              alt=""
              style="width: 213px; height: 142px"
            />
            <div class="t_news_title">
              {{ item.title }}
            </div>
            <div class="t_news_date">{{ item.publishTime }}</div>
            <div class="t_news_so">
              {{ item.contentAbstract }}
            </div>
          </div>
        </div>
      </div> -->
      <!-- 法律法规 -->
      <div v-if="navtab2" style="width: 100%">
        <LawStatute :clcki-name="clckiName" />
      </div>
      <!-- 政策文件 -->
      <div v-if="navtab3" style="width: 100%">
        <Policy :clcki-name="clckiName" />
      </div>
      <!-- 新闻中心列表 -->
      <div v-if="navtab4" style="width: 100%">
        <div
          v-for="(item, k) in t_news_listXwzxlb"
          :key="k"
          class="t_news_list"
          style="cursor: pointer"
          @click="hXwzxlb(item, '详情')"
        >
          <!-- <img src="@/assets/img/newsimg.png" alt="" /> -->
          <img :src="item.picture" alt="">
          <div>
            <div style="font-size: 16px; color: #333333">
              {{ item.title }}
            </div>
            <div
              style="
                font-size: 13px;
                color: #636363;
                margin-top: 15px;
                margin-bottom: 15px;
              "
            >
              {{ item.publishTime }}
            </div>
            <div
              style="
                font-size: 13px;
                color: #636363;
                word-break: break-all;
                text-overflow: ellipsis;
                display: -webkit-box;
                -webkit-box-orient: vertical;
                -webkit-line-clamp: 2;
                overflow: hidden;
              "
            >
              {{ item.contentAbstract }}
            </div>
          </div>
        </div>
        <div style="text-align: center; margin-top: 30px; margin-bottom: 30px">
          <el-pagination
            background
            layout="prev, pager, next"
            :total="t_news_listXwzxlb.length"
          />
        </div>
      </div>
      <!-- 帮助中心 -->
      <!-- 帮助中心 -->
      <div v-if="navtab5" style="width: 100%">
        <div class="t_help_box">
          <div class="t_help_con">
            <div class="t_help_title">
              <img src="@/assets/img/czsc.png" alt="">
              操作手册
            </div>
            <!-- <div class="t_help_itembox">操作手册上传中</div> -->
            <div class="t_help_itembox">
              <div>企业端功能介绍操作手册.pdf</div>
              <div>更新时间：2022-1-12</div>
              <div class="t_help_down">
                <img
                  v-preventReClick
                  src="@/assets/img/xz.png"
                  alt=""
                  @click="downloadsc"
                >
                下载手册
              </div>
            </div>
            <div class="t_help_line" />
            <div class="t_help_title">
              <img src="@/assets/img/spjj.png" alt="">
              视频教程
            </div>
            <!-- <div class="t_help_itembox">视频教程上传中</div> -->
            <div
              v-for="(item, index) in videoList"
              :key="index"
              class="t_help_itembox"
            >
              <img
                v-preventReClick
                src="@/assets/img/fm.png"
                style="width: 125px; height: 80px; cursor: pointer"
                @click="lookvideo(item)"
              >
              <div style="width: 150px">{{ item.name }}视频教程</div>
              <div>更新时间：{{ updateTime }}</div>
              <div class="t_help_down">
                <img
                  v-preventReClick
                  src="@/assets/img/xz.png"
                  alt=""
                  @click="downloadsp(item)"
                >
                下载视频
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- 更新日志 -->
      <div v-if="navtab7" style="width: 100%">
        <UpdateLog :clcki-name="clckiName" />
      </div>
      <!-- @y新闻中心详情 -->
      <div v-if="navtab6" style="width: 100%">
        <newsCentralDetail
          :news-central-detail-name="newsCentralDetailName"
          :news-central-detail-i-d="newsCentralDetailID"
        />
      </div>
      <!-- @y许可证编号核查 -->
      <div v-if="XkzbhhcDetaiShow" style="width: 100%; margin-bottom: 20px">
        <XkzbhhcDetail :zsimg="zsimg" />
      </div>
      <XxhdDocument
        v-if="XxhdDocumentShow"
        :title="title"
        :fbsj="fbsj"
        :fbjg="fbjg"
        :content="content"
        :fj-url="fjUrl"
        :clcki-name="clckiName"
      />
    </div>
    <!-- 注册 -->
    <el-dialog
      v-loading="loading"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="注册"
      :visible.sync="registwid"
      width="600px"
      @close="registClose"
    >
      <el-form
        ref="registform"
        :model="registform"
        :rules="rules"
        style="width: 500px; margin-left: auto; margin-right: auto"
        label-position="top"
      >
        <el-form-item prop="userName">
          <div style="line-height: normal; font-size: 14px">姓名</div>
          <el-input
            v-model="registform.userName"
            size="small"
            placeholder="请输入姓名"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item prop="phonenumber">
          <div style="line-height: normal; font-size: 14px">手机号</div>
          <el-input
            v-model="registform.phonenumber"
            size="small"
            placeholder="请输入手机号"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item prop="code">
          <div style="line-height: normal; font-size: 14px">验证码</div>
          <el-input
            v-model="registform.code"
            size="small"
            style="width: 422px; margin-right: 10px"
            placeholder="请输入验证码"
            autocomplete="off"
          />
          <el-button
            v-preventReClick
            size="small"
            style="
              width: 68px;
              background-color: #0f70ff;
              border-color: #0f70ff;
            "
            type="primary"
            @click="getcode('registe')"
          >{{ codetime }}</el-button>
        </el-form-item>
        <el-form-item prop="password">
          <div style="line-height: normal; font-size: 14px">密码</div>
          <el-input
            v-model="registform.password"
            size="small"
            placeholder="请输入密码"
            autocomplete="off"
            :type="flag ? 'text' : 'password'"
          >
            <i
              slot="suffix"
              :class="flag ? 'el-icon-minus' : 'el-icon-view'"
              style="margin-top: 12px; font-size: 18px"
              autocomplete="auto"
              @click="flag = !flag"
            />
          </el-input>
        </el-form-item>
        <el-form-item prop="passwordAgain">
          <div style="line-height: normal; font-size: 14px">再次输入密码</div>
          <el-input
            v-model="registform.passwordAgain"
            size="small"
            placeholder="请再次输入密码"
            autocomplete="off"
            :type="flag2 ? 'text' : 'password'"
          >
            <i
              slot="suffix"
              :class="flag2 ? 'el-icon-minus' : 'el-icon-view'"
              style="margin-top: 12px; font-size: 18px"
              autocomplete="auto"
              @click="flag2 = !flag2"
            />
          </el-input>
          <!-- <el-input
            size="small"
            v-model="registform.passwordAgain"
            placeholder="请再次输入密码"
            autocomplete="off"
            :type="[flag2 ? 'text' : 'password']"
          >
            <i
              slot="suffix"
              :class="[flag2 ? 'el-icon-minus' : 'el-icon-view']"
              style="margin-top: 12px; font-size: 18px"
              autocomplete="auto"
                 v-preventReClick   @click="flag2 = !flag2"
            />
          </el-input> -->
        </el-form-item>
      </el-form>
      <div slot="footer" style="text-align: center">
        <el-button
          size="small"
          style="margin-right: 40px"
          @click="registClose"
        >取 消</el-button>
        <el-button
          size="small"
          style="background-color: #0f70ff; border-color: #0f70ff"
          type="primary"
          :loading="upregLoading"
          @click="upreg"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- app下载 -->
    <el-dialog
      title="安卓版APP下载"
      :visible.sync="dialogVisible"
      center
      width="400px"
    >
      <div style="text-align: center">
        <img src="@/assets/img/ewm_1.png" style="width: 200px">
      </div>
      <div style="text-align: center; margin-top: 30px">
        <el-button
          v-preventReClick
          type="primary"
          style="border: none; background-color: #0f70ff"
          size="mini"
          @click="dialogVisible = false"
        >确 定</el-button>
      </div>
    </el-dialog>
    <!-- 视频弹窗 -->
    <el-dialog
      :title="activeVideo.name"
      :fullscreen="true"
      :visible.sync="spwindow"
      @close="closevideo"
    >
      <div style="text-align: center; height: 80vh">
        <video
          id="video01"
          style="height: 100%"
          :src="urlStr + activeVideo.key + '.mp4'"
          controls
        />
      </div>
    </el-dialog>
    <!-- 忘记密码 -->
    <el-dialog title="忘记密码" :visible.sync="forgetpwd" width="500px" @close="wjmmClose">
      <el-form
        ref="forgetform"
        :model="forgetform"
        :rules="rules"
      >
        <el-form-item prop="phonenumber">
          <div style="line-height: normal; font-size: 14px">手机号</div>
          <el-input
            v-model="forgetform.phonenumber"
            size="small"
            placeholder="请输入手机号"
            autocomplete="off"
          />
        </el-form-item>
        <el-form-item prop="code">
          <div style="line-height: normal; font-size: 14px">验证码</div>
          <el-input
            v-model="forgetform.code"
            size="small"
            style="width: 382px; margin-right: 10px"
            placeholder="请输入验证码"
            autocomplete="off"
          />
          <el-button
            v-preventReClick
            size="small"
            style="
              width: 68px;
              background-color: #0f70ff;
              border-color: #0f70ff;
            "
            type="primary"
            @click="getcode('reset')"
          >{{ codetime2 }}</el-button>
        </el-form-item>
        <el-form-item prop="newPassword">
          <div style="line-height: normal; font-size: 14px">密码</div>
          <el-input
            v-model="forgetform.newPassword"
            size="small"
            placeholder="请输入密码"
            autocomplete="off"
            :type="flag3 ? 'text' : 'password'"
          >
            <i
              slot="suffix"
              :class="flag3 ? 'el-icon-minus' : 'el-icon-view'"
              style="margin-top: 12px; font-size: 18px"
              autocomplete="auto"
              @click="flag3 = !flag3"
            />
          </el-input>
        </el-form-item>
      </el-form>
      <div style="text-align: center">
        <el-button
          size="small"
          @click="wjmmClose()"
        >取 消</el-button>
        <el-button
          v-preventReClick
          size="small"
          style="
            background-color: #0f70ff;
            border-color: #0f70ff;
            margin-left: 30px;
          "
          type="primary"
          @click="wjpwd"
        >确 定</el-button>
      </div>
    </el-dialog>

    <!-- 底部版权 copyright -->
    <!-- <div class="copyright">
      <div class="copyrightWrapper">
        <div class="yqljContainer">
          <div class="mainContainer">
            <span>友情链接:</span>
            <span class="gab" @click="toLink('gab')">公安部</span>
            <span class="gab" @click="toLink('zgjdw')">中国禁毒网</span>
            <span class="zgjcw" @click="toLink('zgjcw')">中国警察网</span>
          </div>
        </div>
      </div>
    </div> -->
    <div class="bqcontainer">
      <div class="copyrightWrapper">
        <span
          style="width: 275px; text-align: center"
        >©gayzd.com
          <a
            href="http://beian.miit.gov.cn/"
            target="_blank"
            style="text-decoration: none"
          > 京ICP备11029726号-2</a></span>
      </div>
    </div>
    <!-- 悬浮按钮 -->
    <div v-if="xuanfuBtnShow" class="xuanfuBtn">
      <div class="xuanfuBtn_tx" />
      <div class="anBtn" @click="hxuanfuBtn('czsc')">
        操作手册
        <span />
      </div>
      <div class="anBtn" @click="hxuanfuBtn('lyb')">
        留言板
        <span />
      </div>

      <div class="anBtn" @click="hxuanfuBtn('cywt')">
        常见问题
        <span />
      </div>

      <i
        class="el-icon-arrow-right"
        @click="xuanfuBtnShow = !xuanfuBtnShow"
      />
    </div>
    <div
      v-else
      class="xuanfuBtn_zhankai"
      @click="xuanfuBtnShow = !xuanfuBtnShow"
    >
      <i class="el-icon-arrow-left" />
    </div>
    <el-dialog
      title="联系我们"
      :visible.sync="centerDialogVisible"
      width="420px"
      center
    >
      <!-- <span>需要注意的是内容是默认不居中的</span>
      <span>需要注意的是内容是默认不居中的</span>
      <span>需要注意的是内容是默认不居中的</span> -->
      <div
        v-for="(item, index) in kfrxList"
        :key="index"
        class="mainListItem_lx"
      >
        <i class="el-icon-phone-outline icon_lx" />
        <span>客服热线:</span>
        <span class="tel">{{ item }}</span>
      </div>
      <div class="instruction_lx">
        <span>业务相关问题可在页面右下角点击常见问题、下载操作手册或在留言板进行留言。</span>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button
          type="primary"
          style="
            height: 30px;
            line-height: 30px;
            padding: 0px 20px;
            background-color: #4170ff;
            border-color: #4170ff;
          "
          @click="centerDialogVisible = false"
        >确 定</el-button>
      </span>
    </el-dialog>
    <!--注册或忘记密码的验证码弹窗-->
    <el-dialog title="请完成校验" :visible.sync="txjymShow" width="260px" @close="txjymlose">
      <div>
        <img style="cursor: pointer" :src="smsImg" @click = "codeimgSms"/>
        <el-input v-model="smsCode" placeholder="请输入图形校验码"></el-input>
      </div>
      <div style="text-align: center;margin-top:20px;">
        <el-button
          size="small"
          @click="txjymlose()"
        >取 消</el-button>
        <el-button
          v-preventReClick
          size="small"
          style="
            background-color: #0f70ff;
            border-color: #0f70ff;
            margin-left: 30px;
          "
          type="primary"
          @click="senSms"
        >确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import newsCentralDetail from './newsCentralDetail'

// 法律法规
import LawStatute from '../components/xxhd/flfg/lawStatute.vue'

// 更新日志
import UpdateLog from '../components/updateLog.vue'

// 政策文件
import Policy from '../components/xxhd/zcwj/policy.vue'
import XxhdDocument from '../components/xxhd/xxhdDocument.vue'
// 许可证编号
import XkzbhhcDetail from './XkzbhhcDetail.vue'
import { JSEncrypt } from 'jsencrypt'
import {
  APIflfgAll,
  APIzcwjAll,
  APIhuoquxiangqingSY,
  APIxwzxSY,
  APIxwzxXQlb, getKfdh, getKfdhList
} from '@/assets/js/wangshuai.js'

import { returnShowPic, getToken } from '@/assets/js/common.js'
import { login, getVerifyCode, registerUser, resetPassWord, sms } from '@/assets/js/login'
import { setToken } from '@/utils/tool'
export default {
  name: 'Login',
  components: {
    LawStatute,
    UpdateLog,
    Policy,
    XxhdDocument,
    newsCentralDetail,
    XkzbhhcDetail
  },
  data() {
    const pwdValidate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('密码不能为空!'))
      } else if (value) {
        const reg = new RegExp(/((^(?=.*[a-z])(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[A-Z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*\W)[\da-zA-Z\W]{8,16}$)|(^(?=.*\d)(?=.*[a-z])(?=.*[A-Z])[\da-zA-Z\W]{8,}$))/)
        if (!reg.test(value)) {
          callback(new Error('密码必须同时包含大写、小写、数字和特殊字符其中三项且至少8位'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const telphoneValidate = (rule, value, callback) => {
      if (!value) {
        callback(new Error('手机号不能为空!'))
      } else if (value) {
        const reg = /^1[3456789]\d{9}$/
        if (!reg.test(value)) {
          callback(new Error('请输入正确的手机号'))
        } else {
          callback()
        }
      } else {
        callback()
      }
    }
    const codeValidate = (rule, value, callback) => {
      if ((this.registwid && !this.registform.phonenumber) || (this.forgetpwd && !this.forgetform.phonenumber)) {
        callback(new Error('请先输入手机号!'))
      } else {
        if (!value) {
          callback(new Error('请输入验证码!'))
        }
        if (/^\d{6}$/.test(value) == false) {
          callback(new Error('验证码错误!'))
        }
      }
      callback()
    }
    const passwordValidate = (rule, value, callback) => {
      if (this.registform.password && this.registform.password != value) {
        callback(new Error('两次密码不一致,请重新确认!'))
      }
      callback()
    }

    return {
      kfdh:'', //客服电话
      // 注册提交 确定按钮 loading
      upregLoading: false,
      //忘记密码 或 注册 的图形校验码
      txjymShow: false,
      kfrxList: [],
      centerDialogVisible: false,
      // 轮播列表
      swiperList: [
        {
          curImg: require('../assets/img/login/01.png'),
          curIndex: 0
        },
        {
          curImg: require('../assets/img/login/02.png'),
          curIndex: 1
        },
        {
          curImg: require('../assets/img/login/03.png'),
          curIndex: 2
        },
        {
          curImg: require('../assets/img/login/04.png'),
          curIndex: 3
        }
      ],
      // 视频教程列表
      videoList: [
        { key: 'video1', name: '用户注册' },
        { key: 'video2', name: '企业入网' },
        { key: 'video3', name: '库存初始化' },
        { key: 'video4', name: '购买证申请' },
        { key: 'video5', name: '运输证申请' },

        { key: 'video6', name: '生产入库' },
        { key: 'video7', name: '购买入库' },
        { key: 'video8', name: '退货入库' },
        { key: 'video9', name: '内部退回' },
        { key: 'video10', name: '增溢入库' },

        { key: 'video11', name: '其他入库' },
        { key: 'video12', name: '销售出库' },
        { key: 'video13', name: '使用出库' },
        { key: 'video14', name: '退货出库' },
        { key: 'video15', name: '移库报备' },

        { key: 'video16', name: '运输报备' },
        { key: 'video17', name: '损耗出库' },
        { key: 'video18', name: '其他出库' }
      ],
      updateTime: '2022-1-18', // 更新时间
      activeVideo: {}, // 当前视频对象
      urlStr: process.env.VUE_APP_PUBLIC_PORT + '/videoCourse/', // 视频教程url
      // 验证码图片
      codeimgurl: '',
      // 证书
      zsimg: '',
      loading: false,
      // 搜所编号
      searchbh: '',
      // 忘记密码
      forgetpwd: false,
      // 视频弹窗
      spwindow: false,
      // 当前tab
      isActive: 1,
      dialogVisible: false,
      clckiName: '首页',
      XkzbhhcDetaiShow: false, // 许可证编号
      // navtab
      navtab1: true,
      navtab2: false,
      navtab3: false,
      navtab4: false,
      navtab5: false,
      navtab6: false,
      navtab7: false,

      tzgg: true,
      flfg: false,
      flag: false,
      flag2: false,
      flag3: false,
      topimg: require('@/assets/img/bannertop.jpg'),
      username: '',
      password: '',
      code: '',
      uuid: '',
      //下面5个属性都是注册或忘记密码 涉及发送短信验证码
      smsImg: '',
      smsUuid: '',
      smsCode: '',
      smsType: '',
      smsNumber: '',
      // 获取验证码
      codetime: '验证码',
      codetime2: '验证码',
      // 注册弹窗
      registwid: false,
      registform: {
        userName: '',
        phonenumber: '',
        code: '',
        password: '',
        passwordAgain: ''
      },
      forgetform: {
        phonenumber: '',
        code: '',
        newPassword: ''
      },
      // tab切换  法律法规 / 政策文件
      flfgData: [],
      zcwjData: [],
      // 详情页数据
      title: '',
      fbsj: '',
      fbjg: '',
      content: '',
      fjUrl: '',
      XxhdDocumentShow: false,

      // 新闻中心
      t_news_boxData: [],

      // teb栏新闻中心
      t_news_listXwzxlb: [],
      newsCentralDetailName: '',
      newsCentralDetailID: 0,
      rules: {
        userName: [
          { required: true, message: '请输入姓名', trigger: 'change' }
        ],
        phonenumber: [
          { required: true, validator: telphoneValidate, trigger: 'change' }
        ],
        code: [{ required: true, validator: codeValidate, trigger: 'change' }],
        password: [
          { required: true, validator: pwdValidate, trigger: 'change' }
        ],
        passwordAgain: [
          { required: true, validator: passwordValidate, trigger: 'blur' }
        ],
        newPassword: [
          { required: true, validator: pwdValidate, trigger: 'change' }
        ]
      },
      xuanfuBtnShow: true // 悬浮按钮
    }
  },
  created() {
    // 获取验证码图片
    this.codeimg()
  },

  mounted() {
    //获取客服热线
    this.getKfrx()
    // 调取法律法规
    this.hallflfg()

    // 获取首页新闻中心
    this.hallxwzx()
  },
  methods: {
    isEmpty(obj) {
      return typeof obj === 'undefined' || obj == null || obj === ''
    },
    connectToUs() {
      this.centerDialogVisible = true
    },
    // 悬浮按钮
    hxuanfuBtn(val) {
      if (val == 'czsc') {
        this.downloadsc()
      } else {
        if (!getToken()) {
          this.$message.error('请先登录')
        }
      }
    },
    registClose() {
      this.registwid = false
      this.txjymlose()
      this.$refs['registform'].resetFields()
    },
    // 友情链接跳转2022/1/1
    toLink(type) {
      if (type == 'gab') {
        window.open('https://www.mps.gov.cn/')
      } else if (type == 'zgjdw') {
        window.open('http://www.nncc626.com/')
      } else {
        window.open('http://www.cpd.com.cn/')
      }
    },
    // 根据许可证进行核查
    hcShow() {
      if (this.searchbh) {
        // var that = this;
        // that.XkzbhhcDetaiShow = true;
        // that.navtab1 = false;
        // that.navtab2 = false;
        // that.navtab3 = false;
        // that.navtab4 = false;
        // that.navtab5 = false;
        // that.navtab6 = false;
        // that.navtab7 = false;
        // this.XxhdDocumentShow = false;
        // that.zsimg =
        //   url2() +
        //   "/yzdservice/api/enterprise/credentials/common/downloadImgno/" +
        //   that.searchbh;
        this.$message.error('此功能正在维护中，请之后再使用')
      } else {
        this.$message.error('请输入')
      }
    },
    // 新闻中心点击详情
    hXwzxlb(data, val) {
      this.newsCentralDetailID = data.id
      this.newsCentralDetailName = val
      this.navtab6 = true
      this.navtab4 = false
      this.navtab1 = false
      this.XkzbhhcDetaiShow = false
    },

    // 法律法规 政策文件 详细信息
    hflfgData(data) {
      APIhuoquxiangqingSY(data.flfgId).then((res) => {
        this.title = res.data.data.title
        this.fbsj = res.data.data.publishTime
        this.fbjg = res.data.data.deptName
        this.content = res.data.data.content
        this.fjUrl = res.data.data.fj
        this.navtab1 = false
        this.XxhdDocumentShow = true
        this.XkzbhhcDetaiShow = false
      })
    },
    // tab切换
    // 通知公告tab
    tzggtab() {
      this.flfg = false
      this.tzgg = true
      this.XkzbhhcDetaiShow = false
      this.hallflfg()
    },
    // 法律法规tab
    flfgtab() {
      this.flfg = true
      this.tzgg = false
      this.XkzbhhcDetaiShow = false
      this.hallzcwj()
    },
    // 登录
    login() {
      const encrypt = new JSEncrypt()
      encrypt.setPublicKey('MIGfMA0GCSqGSIb3DQEBAQUAA4GNADCBiQKBgQCnSEqpdMezpGjpIWFikvN/qgI1FKP6AjTpwVLBJ5t7HkfMQYgsjugpLwUknzgsLhlYH3hgOkeSH92GJcsp7IRgKEHEym0tGye+pDJopqQPRIaveVYRV5f1rjWZnDZnQcoF9eAYpQNuUO84/x9PoazOspVVfoJfppRBM5nEjoBc8wIDAQAB')
      const usernameRsa = encrypt.encrypt(this.username)
      const passwordRsa = encrypt.encrypt(this.password)

      login({
        username: usernameRsa,
        password: passwordRsa,
        code: this.code,
        uuid: this.uuid
      })
        .then((e) => {
          // 跳转
          if (e.data.tokenType && e.data.tokenType.includes('Bjump')) {
            let jumpPath = e.data.jumpUrl + '?token=' + e.data.accessToken
            if (e.data.jumpUrl.indexOf('http') !== 0) {
              jumpPath = 'http://' + jumpPath
            }
            location.href = jumpPath
            return
          }
          var token = e.data.tokenType + e.data.accessToken
          var time = e.data.expiresIn - 60 + 's'
          // // 填写Date对象，明确指定过期时间
          setToken(token, time, e.data)
          // 判断单位审核状态
          //  1 审批通过
          //  0 正在审批中
          //  3 审批未通过
          //  5 未入网
          if (e.data.qyState == 5) {
            // 未申请
            this.$router.push('/Rwsq')
          } else if (e.data.qyState == 1) {
            // 申请通过
            if (e.data.isInit == true) {
              // 跳转库存初始化
              this.$router.push('/Kccshlc')
            } else {
              // 跳转首页
              this.$router.push('/Dashboard')
            }
          } else if (e.data.qyState == 3) {
            // 未通过
            this.$router.push('/Spfail')
          } else if (e.data.qyState == 0) {
            // 审核中
            this.$router.push('/Spload')
          }
        })
        .catch(e => {
          console.log('error', e)
          // 获取验证码图片
          this.codeimg()
        })
    },
    // 注册
    register() {
      this.registwid = true
    },
    // 获取验证码图片
    codeimg() {
      getVerifyCode().then((e) => {
        this.uuid = e.data.data.uuid
        this.codeimgurl = e.data.data.img
      })
    },
    // 忘记密码或注册：获取验证码图片
    codeimgSms() {
      getVerifyCode().then((e) => {
        this.smsUuid = e.data.data.uuid
        this.smsImg = e.data.data.img
      }).catch(()=>{
        this.smsUuid = ''
        this.smsImg = ''
      })
    },
    // 提交注册
    upreg() {
      this.$refs['registform'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.upregLoading = true
          registerUser(this.registform).then((e) => {
            this.$message({
              message: '注册成功！',
              type: 'success'
            })
            this.registwid = false
            this.txjymlose()
            this.loading = false
            this.upregLoading = false
          }).catch((e) => {
            this.loading = false
            this.upregLoading = false
          })
        }
      })
    },
    // 获取验证码
    getcode(type) {
      if (type == 'registe') {
        if (this.codetime == '验证码') {
          this.registform.phonenumber
            ? this.getcodefunc(type, this.registform.phonenumber)
            : this.$message.error('请输入手机号码')
        }
      } else {
        if (this.codetime2 == '验证码') {
          this.forgetform.phonenumber
            ? this.getcodefunc(type, this.forgetform.phonenumber)
            : this.$message.error('请输入手机号码')
        }
      }
    },
    // navtab切换
    nav(i) {
      this.isActive = i
      this.XxhdDocumentShow = false
      this.navtab6 = false
      if (i == 1) {
        this.navtab1 = true
        this.navtab2 = false
        this.navtab3 = false
        this.navtab4 = false
        this.navtab5 = false
        this.navtab7 = false
        this.XkzbhhcDetaiShow = false
      } else if (i == 2) {
        this.navtab1 = false
        this.navtab2 = true
        this.navtab3 = false
        this.navtab4 = false
        this.navtab5 = false
        this.navtab7 = false
        this.XkzbhhcDetaiShow = false
      } else if (i == 3) {
        this.navtab1 = false
        this.navtab2 = false
        this.navtab3 = true
        this.navtab4 = false
        this.navtab5 = false
        this.navtab7 = false
        this.XkzbhhcDetaiShow = false
      } else if (i == 4) {
        APIxwzxXQlb({ page: 1, size: 10, param: {}}).then((res) => {
          this.navtab1 = false
          this.navtab2 = false
          this.navtab3 = false
          this.navtab4 = true
          this.navtab5 = false
          this.navtab7 = false
          this.XkzbhhcDetaiShow = false
          this.t_news_listXwzxlb = res.data.data.rows
          this.t_news_listXwzxlb.forEach((item) => {
            item.picture = returnShowPic() + item.picture
          })
        })
      } else if (i == 5) {
        this.navtab1 = false
        this.navtab2 = false
        this.navtab3 = false
        this.navtab4 = false
        this.navtab5 = true
        this.navtab7 = false
        this.XkzbhhcDetaiShow = false
      } else if (i == 7) {
        this.navtab1 = false
        this.navtab2 = false
        this.navtab3 = false
        this.navtab4 = false
        this.navtab5 = false
        this.navtab7 = true
        this.XkzbhhcDetaiShow = false
      }
    },
    // 获取客服热线
    getKfrx() {
      getKfdh().then((res) => {
        this.kfdh = res.data.data
      })
      getKfdhList().then((res) => {
        this.kfrxList = res.data.data
      })
    },
    // 获取首页切换中 法律法规
    hallflfg() {
      APIflfgAll().then((res) => {
        this.flfgData = res.data.data
      })
    },
    // 获取首页切换中 政策文件
    hallzcwj() {
      APIzcwjAll().then((res) => {
        this.zcwjData = res.data.data
      })
    },

    // 获取首页新闻中心
    hallxwzx() {
      APIxwzxSY().then((res) => {
        this.t_news_boxData = res.data.data

        this.t_news_boxData.forEach((item) => {
          item.picture = returnShowPic() + item.picture
        })
      })
    },
    // app下载
    appdownload() {
      this.dialogVisible = true
    },
    // 手册下载
    downloadsc() {
      const link = document.createElement('a')
      link.href = process.env.VUE_APP_PUBLIC_PORT + '/operationManual.pdf'
      link.download = '易制毒化学品管理服务平台操作手册'
      link.click()
    },
    // 视频下载
    downloadsp(item) {
      const link = document.createElement('a')
      link.href = this.urlStr + item.key + '.mp4'
      link.download = item.name + '视频教程'
      link.click()
    },
    // 查看视频
    lookvideo(item) {
      this.activeVideo = item
      this.spwindow = true
    },
    // 关闭视频弹窗
    closevideo() {
      var video = document.getElementById('video01')
      video.pause() // 暂停控制
    },
    // 忘记密码
    wjpwd() {
      this.$refs['forgetform'].validate((valid) => {
        if (valid) {
          resetPassWord(this.forgetform)
            .then((e) => {
              this.$message({
                message: '修改成功！',
                type: 'success'
              })
              this.forgetpwd = false
              this.txjymlose()
            })
        }
      })
    },
    wjfont() {
      this.forgetpwd = true
      this.forgetform.phonenumber = ''
      this.forgetform.code = ''
      this.forgetform.newPassword = ''
    },
    wjmmClose() {
      this.forgetpwd = false
      this.txjymlose()
      this.$refs['forgetform'].resetFields()
    },
    txjymlose() {
      this.txjymShow = false
      this.smsUuid = ''
      this.smsImg = ''
      this.smsCode = ''
      this.smsNumber = ''
      this.smsType = ''
    },
    // 获取验证码
    getcodefunc(type, number) {
      this.codeimgSms()
      this.smsType = type
      this.smsNumber= number
      this.txjymShow = true
    },
    //发送短信验证码
    senSms(){
      let type = this.smsType
      sms({mobilePhone:this.smsNumber,type:type,code:this.smsCode,uuid:this.smsUuid})
        .then((e) => {
          this.txjymlose()
          this.$message({
            message: '发送成功！',
            type: 'success'
          })
          if (type == 'registe') {
            let time = 60
            this.codetime = 60
            var t = setInterval(() => {
              if (time == 0) {
                this.codetime = '验证码'
                clearInterval(t)
              } else {
                time--
                this.codetime = time
              }
            }, 1000)
          } else {
            let time = 60
            this.codetime2 = 60
            var t = setInterval(() => {
              if (time == 0) {
                this.codetime2 = '验证码'
                clearInterval(t)
              } else {
                time--
                this.codetime2 = time
              }
            }, 1000)
          }
        }).catch((e)=>{
          if(e.response.data.code != '010137'){ //非校验不通过错误，关闭图形校验码弹窗
            this.txjymlose()
          }else{
            this.codeimgSms() //刷新
          }
      })
    }
  }
}
</script>

<style scoped lang="less">
.active {
  border-bottom: 1px solid white;
}
.t_banner_top {
  height: 177px;
  width: 100%;
  background-repeat: no-repeat;
  background-position: center center;
}
.t_banner_con {
  max-width: 1200px;
  margin-left: auto;
  margin-right: auto;
  height: 177px;
}
.t_banner_top_imgbox {
  display: flex;
  height: 100%;
  align-items: center;
}
.t_banner_top_search {
  display: flex;
  height: 52px;
  align-items: center;
  background-color: rgba(255, 255, 255, 0.3);
  box-sizing: border-box;
  padding: 20px 0px 20px 20px;
  border-radius: 2px;
  overflow: hidden;
}
.t_banner_up {
  display: flex;
  justify-content: space-between;
  height: 126px;
  align-items: center;
}
.t_search_btn {
  width: 102px;
  background-color: #0f70ff;
  text-align: center;
  line-height: 52px;
  color: white;
  margin-left: 20px;
  cursor: pointer;
}
.t_banner_top_search input::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: white;
  /* placeholder字体大小  */
  font-size: 12px;
  /* placeholder位置  */
  text-align: left;
}
.t_nav_list {
  display: flex;
  justify-content: space-between;
  color: white;
  line-height: 50px;
  width: 950px;
  margin-left: auto;
  margin-right: auto;
  position: relative;
  cursor: pointer;
}
.t_download_sc {
  position: absolute;
  bottom: 0;
  right: -125px;
}
.t_con_box {
  width: 1200px;
  min-height: calc(100vh - 277px);
  margin-left: auto;
  margin-right: auto;
  display: flex;
  justify-content: space-between;
  flex-wrap: wrap;
  padding-top: 20px;
}
.t_notice_box,
.t_banner_box,
.t_login_box,
.t_flow_box,
.t_news_box {
  box-sizing: border-box;

  margin-bottom: 20px;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.11);
}
.t_notice_box,
.t_banner_box,
.t_login_box {
  height: 400px;
}
.t_flow_box {
  height: 350px;
  padding: 20px;
}
.t_banner_box {
  width: 536px;
}
.t_news_box {
  height: 440px;
  padding: 20px;
}
.t_notice_box,
.t_login_box {
  width: 315px;
  padding: 20px;
}
.t_flow_box,
.t_news_box {
  width: 100%;
}
.t_title_box {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  margin-bottom: 10px;
}
.t_title_color {
  height: 25px;
}
.t_title_no {
  height: 25px;
}
.t_zero {
  width: 4px;
  height: 4px;
  background-color: #2860ec;
  margin-right: 10px;
}
.t_notice_item {
  display: flex;
  align-items: center;
  padding-top: 15px;
  padding-bottom: 15px;
  border-bottom: 1px dashed #e0e0e0;
}
.t_notice_item:last-child {
  border-bottom: none;
}
.t_notice_so {
  width: 100%;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
  font-size: 13px;
  cursor: pointer;
}
.el-carousel__item h3 {
  color: #475669;
  font-size: 14px;
  opacity: 0.75;
  line-height: 150px;
  margin: 0;
}

.el-carousel__item:nth-child(2n) {
  background-color: #99a9bf;
}

.el-carousel__item:nth-child(2n + 1) {
  background-color: #d3dce6;
}
/deep/ .el-carousel__button {
  width: 7px !important;
  height: 7px !important;
  border-radius: 50% !important;
  background-color: white;
}
.t_input_user {
  width: 273px;
  height: 46px;
  outline: none;
  border: none;
  background-color: #f5f5f5;
  padding-left: 20px;
  border-radius: 5px;
}
.t_input_user::-webkit-input-placeholder {
  /* placeholder颜色  */
  color: #989898;
  /* placeholder字体大小  */
  font-size: 12px;
  /* placeholder位置  */
  text-align: left;
}
.t_forgetpwd {
  color: #636363;
  font-size: 13px;
  text-align: right;
  margin-top: 15px;
  margin-bottom: 30px;
  cursor: pointer;
}
.t_login_btnbox {
  display: flex;
  justify-content: space-between;
}
.t_reg,
.t_log {
  width: 113px;
  line-height: 38px;
  text-align: center;
  background-color: #f5f5f5;
  font-size: 14px;
  cursor: pointer;
  border-radius: 2px;
}
.t_step_box {
  text-align: center;
  position: relative;
}
.t_step_item {
  position: absolute;
  font-size: 14px;
}
.t_news_list2 {
  display: flex;
  // /* justify-content: space-between; */
  width: 1056px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  // border-bottom: 1px solid #eaeaea;
  padding-bottom: 30px;
}
.t_news_list {
  display: flex;
  /* justify-content: space-between; */
  width: 1056px;
  margin-left: auto;
  margin-right: auto;
  margin-top: 30px;
  border-bottom: 1px solid #eaeaea;
  padding-bottom: 30px;
}
.t_news_item {
  min-width: 213px;
  width: calc((100% - 204px) / 4);
  height: 320px;
  margin: 0 68px 0 0;
  // background-color: pink;
}
.t_news_item img {
  width: 100%;
  margin-bottom: 15px;
}
.t_news_title {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  line-clamp: 2;
  -webkit-box-orient: vertical;
  font-size: 15px;
  font-weight: 700;
  width: 225px;
  height: 42px;
  font-size: 15px;
  font-family: "PingFangSC-Medium, PingFang SC";
  font-weight: 700;
  color: #333333;
  line-height: 21px;
}
.t_news_so {
  text-overflow: -o-ellipsis-lastline;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 4;
  line-clamp: 4;
  -webkit-box-orient: vertical;
  font-size: 13px;
  color: #636363;
}
.t_news_date {
  font-size: 13px;
  color: #636363;
  margin-top: 15px;
  margin-bottom: 15px;
}
.t_news_list {
  display: flex;
}
.t_news_list img {
  width: 174px;
  height: 116px;
  margin-right: 20px;
  flex-grow: 0;
  flex-shrink: 0;
}
.copyright {
  height: 95px;
  width: 100%;
  line-height: 100px;
  background-color: #030f78;
  .copyrightWrapper {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    font-size: 24px;
    .yqljContainer {
      height: 95px;
      display: flex;
      justify-content: center;
      align-content: center;
      font-size: 16px;
      color: #bdc8ff;
      .mainContainer {
        // width: 600px;
        height: 20px;
        .gab {
          display: inline-block;
          width: 130px;
          text-align: center;
          height: 20px;
          line-height: 20px;
          border-right: 1px solid #bdc8ff;
          cursor: pointer;
          &:hover {
            color: #bdc8ff;
          }
        }
        .zgjcw {
          width: 130px;
          text-align: center;
          display: inline-block;
          height: 20px;
          line-height: 20px;
          cursor: pointer;
          &:hover {
            color: #bdc8ff;
          }
        }
      }
    }
    .bqcontainer {
      height: 85px;
      background-color: plum;
    }
    span {
      color: #fff;
    }
  }
}
.bqcontainer {
  height: 85px;
  width: 100%;
  background-color: #fff;
  .copyrightWrapper {
    width: 1200px;
    height: 100%;
    margin: 0 auto;
    font-size: 16px;
    color: #9a9a9a;
    display: flex;
    justify-content: center;
    align-items: center;
    span {
      display: inline-block;
      width: 380px;
    }
  }
}
.xuanfuBtn {
  width: 130px;
  height: 180px;
  background-color: white;
  position: fixed;
  top: 80%;
  right: 10px;
  z-index: 999999999;
  margin-top: -100px;
  padding-top: 15px;

  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.11);

  .anBtn {
    position: relative;
    width: 90%;
    height: 40px;
    text-align: center;
    line-height: 40px;
    font-size: 14px;
    margin-top: 10px;
    font-weight: 700;
    z-index: 99;
    &:hover {
      color: #007acc;
      cursor: pointer;
    }

    span {
      position: absolute;
      bottom: 10px;
      left: 50%;
      width: 60%;
      height: 8px;
      margin-left: -30%;
      background-color: #f9e0a2;
      border-radius: 4px;
      z-index: -1;
    }
  }

  .el-icon-arrow-right {
    font-size: 16px;
    width: 10%;
    position: absolute;
    top: 0;
    right: 0;
    height: 100%;
    text-align: center;
    line-height: 180px;

    &:hover {
      background-color: rgba(0, 0, 0, 0.11);
      cursor: pointer;
    }
  }

  .xuanfuBtn_tx {
    width: 40px;
    height: 40px;
    background-image: url("../assets/img/sftk/tubiao.png");
    position: absolute;
    top: -40px;
    left: 50%;
    margin-left: -20px;
  }
}
.xuanfuBtn_zhankai {
  z-index: 999999999;
  position: fixed;
  top: 80%;
  right: 10px;
  width: 13px;
  height: 180px;
  text-align: center;
  line-height: 180px;
  font-size: 16px;
  margin-top: -100px;
  background-color: white;
  box-sizing: border-box;
  border-radius: 4px;
  box-shadow: 0 0 10px rgba(0, 0, 0, 0.11);
  &:hover {
    background-color: rgba(0, 0, 0, 0.11);
    cursor: pointer;
  }
}
.t_help_box {
  width: 1200px;
  margin-left: auto;
  margin-right: auto;
  border-radius: 5px;
  box-shadow: 0 0 5px #e3e3e3;
  padding-top: 50px;
  padding-bottom: 50px;
}
.t_help_con {
  width: 930px;
  margin-left: auto;
  margin-right: auto;
}
.t_help_title {
  display: flex;
  color: #333333;
  align-items: center;
  padding-left: 20px;
  padding-right: 20px;
}
.t_help_title img {
  height: 20px;
  margin-right: 10px;
}
.t_help_itembox {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  margin-top: 30px;
  padding-left: 20px;
  padding-right: 20px;
  align-items: center;
}
.t_help_down {
  display: flex;
  align-items: center;
}
.t_help_line {
  height: 1px;
  background-color: #eaeaea;
  margin-top: 40px;
  margin-bottom: 40px;
}
.t_help_down img {
  height: 18px;
  margin-right: 10px;
  cursor: pointer;
}
/deep/.el-form-item__label {
  padding: 0px;
}
.mainListItem_lx {
  width: 260px;
  margin: 0 auto;
  color: #000;
  font-size: 16px;
  padding: 30px 0 0 0;
  &:nth-child(1) {
    padding-top: 0;
  }
  display: flex;
  .icon_lx {
    font-size: 18px;
    font-weight: 700;
    margin-right: 8px;
  }
  .tel {
    margin-left: 10px;
  }
}
.instruction_lx {
  margin-top: 30px;
  color: #407cff;
  text-indent: 16px;
  font-size: 16px;
  line-height: 26px;
}
</style>
